import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { defineAsyncComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'indexChart',
  setup(__props) {

const WidgetCharts = defineAsyncComponent(() => import("@/components/theme/widgets/chart/WidgetCharts.vue"))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(WidgetCharts))
  ]))
}
}

})